import { render, staticRenderFns } from "./OCssClasses.vue?vue&type=template&id=6cf44f1c&scoped=true"
import script from "./OCssClasses.vue?vue&type=script&lang=js"
export * from "./OCssClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf44f1c",
  null
  
)

export default component.exports